module.exports = __webpack_public_path__ + "static/media/promo_band_1b.d34072cc.jpg";